export default __webpack_public_path__ + "static/media/vehicle-4.50156ffd.png";